<div class="service-list">
  <div *ngFor="let service of allServices" class="service-item" (click)="selectService(service, selectedDocModal)">
    <h5>{{ service.name }}</h5>
  </div>
</div>

<ng-template #selectedDocModal let-modal>
  <div class="modal-header dark-modal">
    <h4 class="modal-title" id="modal-basic-title">
      {{ selectedService?.name }}
    </h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body dark-modal">
    <!-- Hiển thị hình ảnh trong modal -->
    <div *ngIf="selectedService?.serviceImages?.length > 0" class="service-images">
      <div *ngIf="isLoadingImages" class="text-center">
        <p>Đang tải hình ảnh...</p>
      </div>
      <div *ngIf="!isLoadingImages && imageUrls.length > 0" class="image-container">
        <div *ngFor="let image of imageUrls" class="image-item">
          <img [src]="image" alt="Service Image" class="img-fluid rounded" />
        </div>
      </div>
      <div *ngIf="!isLoadingImages && imageUrls.length === 0" class="text-center">
        <p>Không thể tải hình ảnh</p>
      </div>
    </div>

    <!-- Hiển thị thông tin dịch vụ -->
    <div class="service-info">
      <h6><b>Mô tả:</b></h6>
      <p>{{ selectedService?.description }}</p>

      <div class="price-section">
        <h6><b>Giá:</b></h6>
        <p>{{ selectedService?.price }} 🏵️</p>
      </div>
    </div>
  </div>
  <div class="modal-footer dark-modal">
    <button class="btn btn-outline-warning" (click)="savePlans(modal)">
      Yêu cầu dịch vụ
    </button>
  </div>
</ng-template>


